<!--
 * @Author       : liuxb
 * @Date         : 2020-07-27 14:06:55
 * @Description  : file content
 * @FilePath     : \vue-gaokao-ebook\src\views\photo_upload\index.vue
--> 
<template>
  <div
    :class="pageClass"
    v-loading="loading"
    element-loading-text="上传中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div :class="[`${pageClass}-header`]">
      <img
        :class="[`${pageClass}-header-logo`]"
        src="@/assets/images/header/logo.png"
        alt
      />
      <span :class="[`${pageClass}-header-title`]">拍照答题</span>
    </div>
    <div>
      <!-- <div :class="[`${pageClass}-tips`]">请上传答题图片</div> -->
      <el-upload
        :class="[`${pageClass}-upload`]"
        multiple
        action=" "
        :http-request="submitUpload"
        :show-file-list="false"
        :before-upload="handleBeforeUpload"
        :accept="'image/*'"
        capture="camera"
      >
        <!-- accept=".jpg, .gif, .jpeg, .png" -->
        <button v-if="!showContinue" :class="[`${pageClass}-upload-btn`]">
          开始上传
        </button>
        <button v-else :class="[`${pageClass}-upload-btn`]">继续上传</button>
      </el-upload>
    </div>

    <toast :showToast="showToast" :message="message" @disappear="disappear" />
  </div>
</template>
<script>
import { elUpload } from "element-ui";
import Toast from './toast.vue'
import fileUtils from '@/assets/js/fileUtils.js'
import compressImage from 'lrz' 
import EXIF from 'exif-js'
export default {
  data() {
    return {
      pageClass: "photoUpload",
      fileList: [],
      loading: false,
      params: {
        user_id: "",
        test_id: "",
        question_id: "",
        blank_number: "",
      },
      showContinue: false,
      showToast: false,
      message: '',
    };
  },
  methods: {
    handleBeforeUpload(file) {
      const typeList = ["jpg", "gif", "jpeg", "png"];
      const fileName = file.name;
      const extension = fileName.substr(fileName.lastIndexOf(".") + 1);
      const isRT = typeList.includes(extension);

      if (!isRT) {
        this.message = "支持jpg,gif,jpeg,png格式";
        this.showToast = true;
        return false;
      }
      return new Promise((resolve)=>{
        EXIF.getData(file, function(){
          let orientation = EXIF.getTag(this, 'Orientation');
          if (orientation && orientation === 6) {
            let reader = new FileReader()
            let img = new Image()
            reader.onload = (e) => {
                img.src = e.target.result
                img.onload = function () {
                  const data = fileUtils.rotateImage(img, img.width, img.height)
                  const newFile = fileUtils.dataURLtoFile(data, file.name)
                  resolve(newFile)
                }
            }
            reader.readAsDataURL(file)
          }else if(orientation && orientation === 3){
            let reader = new FileReader()
            let img = new Image()
            reader.onload = (e) => {
                img.src = e.target.result
                img.onload = function () {
                  const data = fileUtils.rotateImage180(img, img.width, img.height)
                  const newFile = fileUtils.dataURLtoFile(data, file.name)
                  resolve(newFile)
                }
            }
            reader.readAsDataURL(file)
          } else {
              resolve(file)
          }
        });
      });
    },
    // 上传文件
    submitUpload(content) {
      // console.log("原始图片的大小 : "+content.file.size);
      this.loading = true;
      // let options  = [{quality:0.1}];
       let _this = this;
       let options = [{quality:0.5}];
       compressImage( content.file,options ).then(function(rst) {
        var arr = rst.base64.split(',');
        var mime = arr[0].match(/:(.*?);/)[1] || 'image/png';
        // 去掉url的头，并转化为byte
        var bytes = window.atob(arr[1]);
        // 处理异常,将ascii码小于0的转换为大于0
        var ab = new ArrayBuffer(bytes.length);
        // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
        var ia = new Uint8Array(ab);
        for (var i = 0; i < bytes.length; i++) {
            ia[i] = bytes.charCodeAt(i);
        }
        let blob = new Blob([ab], {type: mime});
        // this.loading = true;
        let file = new File([blob], Math.random());
        // console.log("压缩后图片的大小 : "+file.size);
        const formData = new FormData();
        // console.log("转化后的文件是 : " ,file);
        formData.append("file", file);
        formData.append("user_id", _this.params.user_id);
        formData.append("test_id", _this.params.test_id);
        formData.append("question_id", _this.params.question_id);
        formData.append("key", `${_this.params.user_id}_${_this.params.test_id}_${_this.params.question_id}`);
        if(_this.params.blank_number != undefined &&  _this.params.blank_number != null){
          formData.append("blank_number", _this.params.blank_number);
        }
        
        
        _this.$axios
          .post(_this.$APIS.UPLOAD_PHTOT, formData, {
            headers: { "Content-Type": "multipart/form-data" }
          })
          .then((res) => {
            if (res.data) {
              _this.loading = false;
              _this.message = '上传成功'
              _this.showToast = true
              _this.showContinue = true
            } else {
              _this.message = res.msg
              _this.showToast = true
              _this.loading = false;
            }
          })
          .catch(() => {
            _this.message = '上传失败'
            _this.showToast = true
            _this.loading = false;
          });
      // } catch (e) {console.log("e : " , JSON.stringify(e));
      //   this.message = '上传失败'
      //   this.showToast = true
      //   this.loading = false;
      // }

            }).catch(function(error) {
                //失败时执行
                console.log("error : " ,error);
            }).always(function() {
                //不管成功或失败，都会执行

            })
      
    },
    disappear() {
      this.showToast = false
    },
    // dataURLtoBlob(dataurl) {
    //   var arr = urlData.split(',');
    //   var mime = arr[0].match(/:(.*?);/)[1] || 'image/png';
    //   // 去掉url的头，并转化为byte
    //   var bytes = window.atob(arr[1]);
    //   // 处理异常,将ascii码小于0的转换为大于0
    //   var ab = new ArrayBuffer(bytes.length);
    //   // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
    //   var ia = new Uint8Array(ab);
    //   for (var i = 0; i < bytes.length; i++) {
    //       ia[i] = bytes.charCodeAt(i);

    //   }
    //   return new Blob([ab], {
    //       type: mime
    //   });
    // },
  },
  components: {
    Toast,
  },
  created() {
    const querys = this.$route.query;
    this.params.user_id = querys.user_id;
    this.params.test_id = querys.test_id;
    this.params.question_id = querys.question_id;
    this.params.blank_number = querys.blank_number;
  },
};
</script>

<style scoped lang="stylus">
.photoUpload {
  width: 100%;
  min-height: 17rem;
  height: 100%;

  &-header {
    height: 300px;
    width: 100%;
    background-color: #5c307d;
    color: #ffffff;
    text-align: center;
    position: relative;
    font-size: 102px;
    line-height: 300px;

    &-logo {
      height: 200px;
      // width: 150px;
      position: absolute;
      top: 0.19rem;
      left: 0.4rem;
    }

    &-title {
      text-align: center;
      line-height: 0.88rem;
    }
  }

  &-tips {
    color: #999;
    width: 100%;
    height: 88px;
    text-align: center;
    line-height: 88px;
  }

  &-upload {
    display: flex;
    margin-top: 800px;

    &-box {
      width: 100%;
      height: auto;
    }

    /deep/ .el-upload {
      margin: 0 auto;
      margin-top: 80px;
    }

    &-btn {
      width: 6rem;
      height: 6rem;
      border-radius: 0.35rem;
      background-color: #5c307d;
      border: none;
      outline: none;
      font-size: 100px;
      color: #ffffff;
      margin: 0 auto;
    }

    /deep/ .el-upload-list__item {
      line-height: 2.4;
    }
  }
}
</style>